import * as base from 'utils/bolt/dynamicData.js';
export * from 'utils/bolt/dynamicData.js';
import Store from 'store/store';

export function transformPageData(data, activePage) {
	const youtubeMatch = data.hero?.youtube?.match(/[&?]v=([^&#]+)|youtu\.be\/([^?&#]+)|^([a-z0-9_-]+)$/i);
	const youtubeId = youtubeMatch?.[1] || youtubeMatch?.[2] || youtubeMatch?.[3];
	const homeEntLink = data.watch?.showHomeEnt && data.watch.homeEntData?.find(e => e?.link?.startsWith('https://homecinema.curzon.com'))?.link;
	const sections = [
		{
			id: 'filmHero',
			component: 'heroSpot',
			data: {
				background: {
					alt: data.hero?.alt,
					desktop: data.hero?.img,
					mobile: data.hero?.mobileImg
				},
				buttons: (data.hero?.buttons?.length
					? data.hero.buttons.map(button => ({ label: button?.label, link: button?.link }))
					: [
						data.synopsis?.content && { label: 'Learn More', link: '#synopsis' },
						(data.watch?.showHomeEnt || data.watch?.showShowtimes) && { label: data.watch?.showShowtimes ? 'Now Showing' : 'Order Now', link: '#watch' }
					]
				).filter(button => button?.label),
				description: data.hero?.description,
				hasGradient: true,
				title: data.hero?.title,
				trailer: !youtubeId ? undefined : {
					trailer: {
						name: '',
						thumbSrc: `https://i.ytimg.com/vi/${youtubeId}/maxresdefault.jpg`,
						youtubeId: youtubeId
					}
				}
			},
		},
		data.synopsis?.content && {
			id: 'filmSynopsis',
			component: 'synopsis',
			data: {
				hash: 'synopsis',
				content: data.synopsis?.content,
				credits: data.synopsis?.credits?.map(e => ({ heading: e?.title, names: e?.content?.replace(/(^[^ ]|.[^ ]|[^ ].)\n/gm, '$1  \n') })).filter(e => e.names),
			},
		},
		data.watch?.showHomeEnt && {
			id: 'boltHomeEnt',
			type: 'homeEnt',
			order: data.watch?.homeEntFirst ? 1 : 2,
			data: {
				regions: 'gb',
				bg: { desktop: { asset: data.watch.onesheet }, mobile: { asset: data.watch.mobileOnesheet } },
				addProducts: {
					digital: data.watch.homeEntData?.reduce?.((data, e) => {
						if (!e?.name) {
							return data;
						}
						data[e.name] = { merchantName: e.name, stream: { [e.name]: { link: e.link } } };
						return data;
					}, {})
				},
				overrideMerchantDetails: data.watch.homeEntData?.reduce?.((data, e) => {
					if (!e?.name) {
						return data;
					}
					data[e.name] = { name: e.name, logo: e.logo };
					return data;
				}, {}),
			}
		},
		data.watch?.showShowtimes && {
			id: 'boltShowtimes',
			type: 'showtimes',
			order: data.watch?.homeEntFirst ? 2 : 1,
			// TODO: better way to handle "default" showtimes values
			data: {
				movieId: data.watch.movieId,
				bg: { desktop: { asset: data.watch.onesheet }, mobile: { asset: data.watch.mobileOnesheet } },
				boundingRegions: {
					gg: true,
					ie: true,
					im: true,
					je: true
				},
				clockFormat: '24',
				noShowtimes: { buttons: { filtersButton: true } },
				notificationBanner: homeEntLink ? {
					chc: {
						contentCarousel: [
							{ label: 'WATCH ON CURZON HOME CINEMA <u>HERE</u>', path: homeEntLink }
						]
					}
				} : null,
				providers: {
					deeplink: 'webedia, mx',
					showtimes: 'webedia, flicks, atom, pathe, ntlive, byexp, ingresso, velox, pow'
				},
				formatsDict: {
					'2D-OV': '2D',
					'priorityRepeatedTimes': '',
				},
				screeningCategories: {
					exclusions: { attributes: true, audioDetails: true, language: true, movieId: true }
				},
				searchInputAriaLabel: '$SEARCH_FIELD_ARIA',
				theaterDistanceUnit: 'km',
				theaterLocalisation: 'intl',
				useV2: true
			},
		},
		(data.watch?.showHomeEnt || data.watch?.showShowtimes) && {
			id: 'filmWatch',
			component: 'stickAndScaleWidget',
			data: {
				hash: 'watch',
				type: (data.watch.showShowtimes && !data.watch?.homeEntFirst) ? 'showtimes' : 'homeEnt',
				disableOnesheet: false,
			},
		},
		data.gallery?.length && {
			id: 'filmGallery',
			component: 'gallery',
			data: {
				hash: 'gallery',
				contentCarousel: data.gallery.map(e => e?.file && { desktopSrc: e?.file, alt: e?.alt, annotation: e?.annotation }).filter(e => e),
				downloadAll: true,
				downloadSingle: true,
				hideArrowsMobile: true
			},
		},
	].filter(e => e);

	// const sectionData = Object.fromEntries(sections.map(s => [s.id, s]));
	const storePages = Store.get().appData.pages || {};

	storePages.set(activePage, {
		base: 'bolt',
		id: activePage,
		data: sections,
		page: 'filmPage',
		type: 'filmPage',
		path: '/film/' + data.url + '/',
		customPageComponent: 'film'
	}).now();

	return sections;
}
